
import { mdiAlert, mdiInformation, mdiClose } from '@mdi/js'
const SESSION_KEY = 'login-banner-dismissed'
const BANNER_CONTENT = {
  frise: {
    bold: 'Vous êtes actuellement en mode public, la visibilité des informations est limitée.',
    text: ' Vous représentez un territoire ou l\'État ?',
    link: 'Identifiez-vous'
  },
  default: {
    bold: 'Vous représentez un territoire ou l\'État ?',
    text: 'Pour accéder à plus d\'informations et suivre vos documents d\'urbanisme,',
    link: 'identifiez-vous',
  }
}

export default {
  name: 'LoginBanner',
  data () {
    return {
      dismissed: false,
      ready: false,
      icons: { mdiInformation, mdiAlert, mdiClose }
    }
  },
  computed: {
    visible () {
      return this.ready && !this.dismissed && !this.isLoginPage && !this.$user.id
    },
    isFrisePage () {
      return this.$route.name && this.$route.name.startsWith('frise')
    },
    isLoginPage () {
      return this.$route.name && this.$route.name.startsWith('login')
    },
    content () {
      return this.isFrisePage ? BANNER_CONTENT.frise : BANNER_CONTENT.default
    }
  },
  mounted () {
    this.dismissed = sessionStorage.getItem(SESSION_KEY) === 'true'
    this.ready = true
  },
  methods: {
    dismiss () {
      this.dismissed = true
      sessionStorage.setItem(SESSION_KEY, 'true')
    }
  }
}
